<template>
 <div >
  <img src="../assets/22.jpg" style="height:350px;width:100%;" alt=""  />
  <div>
    <el-card id="box-cardx" >
        <div slot="header" >
            <span style="color:white;">基金列表</span>
        </div>
        <div v-for="(item,index) in articlelist" :key="index" class="text item">
            <!-- <a :href="'/fund/fundlist/'+item.id" >{{item.title}}</a> -->
            <router-link :to="'/fund/fundlist/'+item.id" id="text"><a href="#">{{item.title}}</a></router-link>
            <hr>
        </div>
    </el-card>
    <div class="control-center">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pagenum"
      :page-size="100"
      layout="prev, pager, next, jumper"
      :total="400">
    </el-pagination>
    </div>
</div>
   <!-- <Intro2></Intro2> -->


 </div>
</template>

<script>
import Cardshow1 from '../components/cardshow1.vue'
import Intro2 from '../components/intro2.vue'
import bus from '../assets/bus.js'

export default {
 components:{

  Cardshow1,
  Intro2,
  bus


 },
 data() {
      return {
        id:'',
        articlelist:[],
        queryInfo: {
        title: '',
        type: '基金报告',
        pagenum: parseInt(this.$route.path.replace('/fund/','')),
        pagesize: '15',
      },
      };
    },
  watch: {
    $route (to, from) {
      if (to.path.replace('/fund/','')!=this.queryInfo.pagenum) {
        // console.log(to.path.replace('/investment/',''))
        this.queryInfo.pagenum = to.path.replace('/fund/','')
        this.getarticlelist()
      }
    }
  },

    created(){
      this.getarticlelist()
      // this.$route.params.id
      // this.handleCurrentChange(this.$route.params.id)
      // this.handleChange(this.$route.params.id)

    },

    methods: {

      handleSizeChange(val) {
        this.queryInfo.pagesize = val
        console.log(`每页 ${val} 条`);
        // this.getarticlelist()
      },
      async handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.queryInfo.pagenum = val;
        this.$router.push('/fund/'+val);
      //   this.$router.push({
      //     name: 'fund',
      //     params:{
      //       id:val1
      //   }
      // })
      //   console.log(this.queryInfo.pagenum)
        this.getarticlelist()
      },
      async handleChange(val) {
        console.log(val);
      },
      async getarticlelist(){
        const res =await this.$http.get('/huayin/get-articles',{params:this.queryInfo}
          )
        this.articlelist=res.data.data
        console.log(this.articlelist[0].id)
        bus.$emit('data',this.articlelist[0].content)
        bus.$emit('data1',this.articlelist[0].title)
      }
    },

}
</script>


<style>

    .text {
    font-size: 14px;
    color: white;
  }

  .item {
    margin-bottom: 25px;
  }
  .text a{
    text-decoration: none;
    color:aliceblue;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  #box-cardx {
    /* text-align: center; */
    width: 60%;
    height: 1000px;
    background-color:rgba(0,0,0,0.7);
    position: relative;
    /* margin-top: -100px; */
    /* margin-left: 100px; */
    margin: 0 auto;
    z-index: 9999;
  }
  .control-center{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/fund.vue